import React from "react";
import { Card, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { WonTouchpointStage } from "../Models/deal-insights-result";
import SalesCoverageEvidence from "./SalesCoverageEvidence";

export default function ClosedWonTouchpoints({ stages }: { stages: WonTouchpointStage[] }) {
  return <Card variant="outlined" sx={{ p: 3, m: 2 }}>
    <Typography variant="subtitle1">Closed-won touchpoints by stage</Typography>
    <Typography variant="caption">Deals closed won within the selected date range, regardless of the Date Type filter. Averages per won deal; deal counts are denominators, not touchpoint counts.</Typography>
    <Table aria-label="Closed-won touchpoints by stage">
      <TableHead><TableRow><TableCell>Stage</TableCell><TableCell>Avg. Marketing Touchpoints per Won Deal</TableCell><TableCell>Avg. Sales Touchpoints per Won Deal at Stage</TableCell><TableCell>Won Deals</TableCell></TableRow></TableHead>
      <TableBody>{stages.map(s => <TableRow key={s.stage}>
        <TableCell>{s.stage}</TableCell><TableCell>{s.avgMarketingTouchpoints}</TableCell>
        <TableCell>{s.avgSalesTouchpoints}<SalesCoverageEvidence coverage={s.salesCoverage} /></TableCell><TableCell>{s.dealCount}</TableCell>
      </TableRow>)}</TableBody>
    </Table>
  </Card>;
}
